// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"383":"fc370e71","384":"9e38004b","510":"255407d8"}[chunkId] + ".chunk.js";
};